'use strict';

angular.module('shiftTraderApp')
  .controller('RightContainerCtrl', function ($scope, Session, ShiftTradesResource, $timeout, $interval, Notifications,
                                              AvailabilityRules, $state, UserAvailabilityChangeRequests, StatisticsService,
                                              $rootScope, UserPermissionsService) {
    $scope.logout = Session.logout;
    $scope.allTrades = [];
    $scope.availableGiveAways = undefined;
    $scope.activeTrades = undefined;
    $scope.activeTradeRequests = undefined;
    $scope.daysOffRequests = undefined;
    $scope.numAvailRequests = undefined;

    $scope.state = {
      meIsDefined: false,
      menuOpen: true
    };

    var decodeTemplateUrlFromEvent = function(routeChangeInfo) {
      if (!_.isUndefined(routeChangeInfo) && !_.isUndefined(routeChangeInfo.templateUrl)) {

        switch(routeChangeInfo.templateUrl) {
          case 'views/WorkPeriods.html':
            return 'schedule';
          case 'views/trades.html':
            return 'trades';
          case 'views/pickups.html':
            return 'pickups';
          case 'views/messages.html':
            return 'messages';
          case 'views/profile.availability.main.html':
            return 'employeeAvailability';
          case 'views/employees.html':
            return 'employees';
          case 'views/manageWorkPeriods.html':
            return 'scheduling';
          case 'views/manageTrades.html':
            return 'manageTrades';
          case 'views/announcements/announcements.list.html':
            return 'storeAnnouncements';
          case 'views/availability.html':
            return 'availability';
          case 'views/availability.analysis.html':
            return 'availability';
          case 'views/availability.requests.list.html':
            return 'availability';
          case 'views/availability.requests.new.html':
            return 'availability';
          case 'views/availability.requests.view.html':
            return 'availability';
          default:
            return 'other';
        }
      } else if (!_.isUndefined(routeChangeInfo) && routeChangeInfo.name && routeChangeInfo.name.length > 0) {
        if (routeChangeInfo.name.indexOf('daysOff.') === 0) {
          return 'daysoff';
        } else {
          return 'other';
        }
      } else {
        return 'other';
      }
    };

    function updateCanViewAdminMenu() {
      $scope.state.canViewAdminMenu = _.any([
        $scope.state.canViewSchedulingPage,
        $scope.state.canViewEmployeesPage,
        $scope.state.canViewTradesPage,
        $scope.state.canViewDaysOffPage,
        $scope.state.canViewAvailabilityPage
      ], function(x) {return x;});
    }


    function setStateForMe() {
      UserPermissionsService.can('ui.scheduling.view_timeline', 'current')
        .then(function(res) {
          $scope.state.canViewSchedulingPage = res;
          updateCanViewAdminMenu();
        });

      UserPermissionsService.can('ui.employees.view_roster', 'current')
        .then(function(res) {
          $scope.state.canViewEmployeesPage = res;
          updateCanViewAdminMenu();
        });

      UserPermissionsService.can('ui.days_off.view_management', 'current')
        .then(function(res) {
          $scope.state.canViewDaysOffPage = res;
          updateCanViewAdminMenu();
        });

      UserPermissionsService.can('ui.availability.view_management', 'current')
        .then(function(res) {
          $scope.state.canViewAvailabilityPage = res;
          updateCanViewAdminMenu();
        });

      UserPermissionsService.can('ui.trades.view_management', 'current')
        .then(function(res) {
          $scope.state.canViewTradesPage = res;
          updateCanViewAdminMenu();
        });
    }


    function calcAndSetSelectedMenuItem(evt, routeData) {
      $scope.currentPage = decodeTemplateUrlFromEvent(routeData || $state.current);
      $('#side_bar_list .side_bar_item').removeClass('selected');
      $('.side_bar_item.current-page-' + $scope.currentPage).addClass('selected');
    }

    $scope.$on('$stateChangeStart', calcAndSetSelectedMenuItem);

    $scope.me = Session.me;
    var lastSessionMeUpdateUnix = 9999999999999999;
    var availabilityRequestsCountFired = false;


    $scope.$on('updatedSessionMe', function(event, isLoggedIn) {
      if (isLoggedIn) {
        $scope.me = Session.me;
        if (angular.isDefined($scope.me) && !_.isNull($scope.me)) {
          $scope.state.meIsDefined = true;
          setStateForMe();
        }
      }


      if (isLoggedIn && (((lastSessionMeUpdateUnix + 15) < moment.utc().unix()) || _.isUndefined($scope.daysOffRequests) || _.isUndefined($scope.activeTradeRequests))) {
        lastSessionMeUpdateUnix = moment.utc().unix();
        $scope.me = Session.me;
        if (angular.isDefined($scope.me) && !_.isNull($scope.me)) {
          $scope.state.meIsDefined = true;

          updateAvailabilityRequestsCount();

          UserPermissionsService.can('availability_rules.view_in_org', 'current')
            .then(function(result) {
              if (result) {
                AvailabilityRules.getAllDaysOffNeedingApproval()
                  .then(function(daysOffRequests) {
                    $scope.daysOffRequests = daysOffRequests;
                  }, function() {
                    $scope.daysOffRequests = [];
                  });
              } else {
                $scope.daysOffRequests = [];

              }
            });



          // do this ShiftTrades query regardless of permissions - will be used for pickups/trades for employees AND managers
          var tradeQueryData = {
            active: true,
            start_time: moment().subtract(1, 'day').format()
          };

          ShiftTradesResource.query(tradeQueryData, function(trades) {
            $scope.allTrades = _.invoke(trades, '$initialize');

            $scope.availableGiveAways = _.filter($scope.allTrades, function(t) {
              // Needs to be a giveaway that has not been accepted, approved, or disapproved and that I did not start
              return t.$isGiveaway() && t.user.id !== $scope.me.id  &&
                !_.any(t.shift_trade_responses, function(resp) {
                  return _.include([10, 20, 21],resp.acceptance_code);
                }) &&
                t.$calculateActive(true) &&
                t.work_period.$isQualifiedForPickup($scope.me);
            });

            $scope.activeTrades = _.filter($scope.allTrades, function(t) {
              if (t.$isGiveaway()) {
                // check that Session.me is initiator of giveaway or has responded with a status of 10 (accepted)
                return (t.user.id === $scope.me.id ||
                  _.any(t.shift_trade_responses, function(resp) {
                    return resp.user.id === $scope.me.id && resp.acceptance_code === 10;
                  })) &&
                    t.$calculateActive(true);
              } else {
                return (t.trade_user.id === $scope.me.id || t.user.id === $scope.me.id) && t.$calculateActive(true);
              }
            });

            UserPermissionsService.can('trades.view_in_org', 'current')
              .then(function(result) {
                if (result) {
                  $scope.activeTradeRequests = _.filter($scope.allTrades, function(t) {
                    return t.$calculateActive(true);
                  });
                }
              })

          }, function(response) {
            console.log('Failed to retrieve trade records from server.');
            console.log(response);
            $scope.allTrades = [];
          });


          // always request UserAvailabilityChangeRequests for the user
          UserAvailabilityChangeRequests.getAll({userId: $scope.me.id, organization_id: Session.getCurrentOrgId()})
            .then(function(uacrs) {
              $scope.active_uacr = _.find(uacrs, function(uacr) {
                return !uacr.$isExpired() && uacr.user_id === $scope.me.id;
              });
            });

        }

      } else if (!isLoggedIn) {
        $scope.activeTradeRequests = undefined;
        $scope.activeTrades = undefined;
        $scope.availableGiveAways = undefined;
        $scope.daysOffRequests = undefined;
      }
    });

    var setupSidebarHover = function() {
      $timeout(function() {
        var body = $('body');

        var checkManageWorkPeriods = function() {
          return /manageWorkPeriods/.test($state.current.name);
        };

        $('#sidebar #side_bar_list').hover(function() {
          checkManageWorkPeriods() && body.addClass('override_menu_open');
        }, function() {
          body.removeClass('override_menu_open');
        });

        $('#sidebar #side_bar_list #menu_icon').on('mousedown touchdown',function() {
          if (body.hasClass('override_menu_open')) {
            body.removeClass('override_menu_open');
          } else {
            checkManageWorkPeriods() && body.addClass('override_menu_open');
          }
        });

        $('#sidebar_accordion_toggle_cover').on('mousedown touchdown', function(event) {
          if (body.hasClass('override_menu_open')) {
            body.removeClass('override_menu_open');
          } else {
            checkManageWorkPeriods() && body.addClass('override_menu_open');
          }

          event.stopPropagation();
        });

      }, 1000);
    };

    // loggedIn var describes whether there is a logged-in user currently using the site
    $scope.state.loggedIn = Session.isLoggedIn();
    $scope.$on('loginStateChanged', function(event, data) {
      $scope.state.loggedIn = data.state;
      if (data.state) {
        setupSidebarHover();
      }
    });

    setupSidebarHover();

    $scope.numberOfNotifications = 0;
    var refreshNotifications = function() {
      if ( Session.isLoggedIn() ) {
        Notifications.getNewNotifications()
          .then(function(notifs) {
            if (angular.isDefined(notifs)) {
              $rootScope.$broadcast('numberOfNotifications', notifs.length);
              $scope.numberOfNotifications = notifs.length;
            }
          }, function() {
            console.log('notification load failed');
          });
      }
    };

    refreshNotifications();
    $interval(function() {
      refreshNotifications();
    }, 30000);

    $scope.$on('sa:unreadOrganizationMessages', function(event, messages) {
      $scope.numberOfAnnouncements = messages.length;
    });

    $scope.$on('sa:availabilityRequestStateChange', function() {
      updateAvailabilityRequestsCount();
    });

    var updateAvailabilityRequestsCount = function() {

      if (Session.getCurrentOrgId() && $scope.state.meIsDefined && !availabilityRequestsCountFired) {
        UserPermissionsService.can('availability_sets.view_in_org', 'current')
          .then(function(result) {
            if (result && Session.getCurrentOrgId() && $scope.state.meIsDefined && !availabilityRequestsCountFired) {
              StatisticsService.getOrgStatistic(Session.getCurrentOrgId(), 'availability_requests_count', {})
                .then(function(response) {
                  availabilityRequestsCountFired = false;
                  $scope.numAvailRequests = response.data.data[0].total;
                });
              availabilityRequestsCountFired = true;
            }
          })
      }
    };

    $timeout(calcAndSetSelectedMenuItem, 1000);
  });
